import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getResidueConversionList,
	addNewResidueConversion,
	updateResidueConversion,
	deleteResidueConversion,
	getResidueConversion,
} from '../residueConversion/thunk';

export const initialState = {
	itemResidueConversionList: [],
	itemResidueConversionDetail: null,
	isResidueConversionLoading: false,
	isResidueConversionSuccess: false,

	dataResidueConversion: null,
	residueConversionList: [],
	residueConversionListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	isReceiving: false,
	isReceived: false,
	isReceptionError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false
};

const ResidueConversionSlice = createSlice({
	name: 'ResidueConversions',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		},
		cleanDataResidueConversion(state, action) {
			state.dataResidueConversion = null;
		},
		restartRegisterResidueConversion(state, action) {
			state.isAdding = false;
			state.isAdded = false;
			state.registerDisabled = false;
		},
	},
	extraReducers: builder => {
		builder.addCase(getResidueConversion.fulfilled, (state, action) => {
			state.isResidueConversionLoading = false;
			state.isResidueConversionSuccess = true;
			state.itemResidueConversionDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getResidueConversion.pending, state => {
			state.isResidueConversionLoading = true;
			state.isResidueConversionSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueConversion.rejected, (state, action) => {
			state.isResidueConversionLoading = false;
			state.isResidueConversionSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getResidueConversionList.pending, state => {
			state.isResidueConversionSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueConversionList.fulfilled, (state, action) => {
			state.itemResidueConversionList = action.payload;
			state.residueConversionList = action.payload;
			state.isLoadingList = false;
			state.isResidueConversionSuccess = true;

			let residueConversionListSelect = [];
			action.payload.map(item =>
				residueConversionListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.residueConversionListSelect = residueConversionListSelect;
		});
		builder.addCase(getResidueConversionList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isResidueConversionSuccess = true;
		});
		builder.addCase(addNewResidueConversion.fulfilled, (state, action) => {
			state.itemResidueConversionList.push(action.payload);
			state.residueConversionList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewResidueConversion.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewResidueConversion.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateResidueConversion.fulfilled, (state, action) => {
			state.itemResidueConversionList = state.itemResidueConversionList.map(residueConversion =>
				residueConversion.residueConversionname === action.payload.old_residueConversion
					? { ...residueConversion, ...action.payload.updated_residueConversion }
					: residueConversion
			);
			state.residueConversionList = state.residueConversionList.map(residueConversion =>
				residueConversion._id.toString() === action.payload._id.toString()
					? { ...residueConversion, ...action.payload }
					: residueConversion
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateResidueConversion.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateResidueConversion.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteResidueConversion.fulfilled, (state, action) => {
			state.itemResidueConversionList = current(state.itemResidueConversionList).filter(
				item => item._id !== action.payload._id
			);
			state.residueConversionList = current(state.residueConversionList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteResidueConversion.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteResidueConversion.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid,
	cleanDataResidueConversion,
	restartRegisterResidueConversion
} = ResidueConversionSlice.actions;

export default ResidueConversionSlice.reducer;